import { api } from './api';

export const outletService = {
  getAll: () => api.get('/outlets').then((res) => res.data || res),
  getById: (id) => api.get(`/outlets/${id}`).then((res) => res.data || res),
  create: (payload) => api.post('/outlets', payload).then((res) => res.data || res),
  update: (id, payload) =>
    api.put(`/outlets/${id}`, payload).then((res) => res.data || res),
  delete: (id) => api.delete(`/outlets/${id}`),
  /** Bulk upload tab: organization by name; per-row results. */
  bulkImport: (outlets) =>
    api.post('/outlets/bulk-import', { outlets }, { silent: true }).then((res) => res.data || res),
  getAuditors: (outletId) =>
    api.get(`/outlets/${outletId}/auditors`).then((res) => res.data || res),
  updateAuditors: (outletId, payload) =>
    api.put(`/outlets/${outletId}/auditors`, payload).then((res) => res.data || res),
};

